export const CREATE_PASSPORT_VISA_DETAIL = "CREATE_PASSPORT_VISA_DETAIL";
export const FETCH_PASSPORT_VISA_DETAIL = "FETCH_PASSPORT_VISA_DETAIL";
export const EDIT_PASSPORT_VISA_DETAIL = "EDIT_PASSPORT_VISA_DETAIL";
